<template>
    <Notification variant="neutral" padding="l" icon="Check" :tier="2">
        <div class="notification-content">
            <div>
                <span class="notification-content-title">
                    {{ title }}
                </span>
                <span class="notification-content-description">
                    {{ description }}
                </span>
            </div>

            <ButtonLink size="m" :onClick="() => onClick(productId)">
                {{ t({ key: 'cancellation.more_about_cancellation' }) }}
            </ButtonLink>
        </div>
    </Notification>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';
    import { t } from '@shared/helpers/translation';
    import Notification from '@ui/components/Notification/Notification.vue';
    import ButtonLink from '@ui/components/Button/ButtonLink.vue';

    export default defineComponent({
        name: 'NonRefundableNotification',
        methods: { t },
        components: {
            Notification,
            ButtonLink,
        },
        props: {
            onClick: { type: Function, required: true },
            productId: { type: String, required: true },
        },
        setup() {
            const title = t({ key: 'shared.special_price' });
            const description = t({
                key: 'cancellation.non_refundable',
                prefix: ' - ',
            });

            return {
                title,
                description,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward 'RefundableNotification.scss';
</style>
